<template>
<span>{{value}}</span>
</template>

<script>
import moment from 'moment'

export default {
	name: "JmTimestamp",

	props: {
		content: [ String, Number, Object ]
	},

	computed: {
		value () {
			const ts = moment(this.content);
			if (Math.abs(ts.diff())/3600000 < 12) {
				// Short format for same day timestamps
				return ts.format("HH:mm");
			}
			return ts.format("YYYY-MM-DD HH:mm");
		}
	}
};
</script>

<style lang="stylus" scoped>
</style>



// WEBPACK FOOTER //
// src/components/widgets/ItemViewWidgets/Timestamp.vue